export const environment = {
  name: 'production',
  production: true,
    auth: {
    url:
      'https://mb-managed-portfolio-admin-users.auth.us-east-1.amazoncognito.com',
    callbackUrl: 'https://managed-portfolio-admin.ctvm.montebravo.com.br/auth',
    region: 'us-east-1',
    userPoolId: 'us-east-1_cVmNegtia',
    userPoolWebClientId: 'aka6c6n96ss97fc3u0rb2hlf0',
  },
  apiUrl: 'https://managed-portfolio-admin.api.ctvm.montebravo.com.br',
  features: {
    /** Use here to define feature toggles */
  },
}
